/*
	to be consistent 
	Event action = ad location
	Event Label = brand
	Event Category = Impression or click
*/
if (typeof __gaTracker === "undefined") {
(function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
  (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
  m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
  })(window,document,'script','//www.google-analytics.com/analytics.js','__gaTracker');
	__gaTracker('create', 'UA-125915743-1');
	__gaTracker('send','pageview');
}
function sendImpression(adbrand, adlocation){
		if(adbrand != undefined){
			__gaTracker('send', {
				hitType: 'event',
				eventCategory: "Sponsored impression",
				eventAction: adlocation,
				eventLabel: adbrand,
				transport: 'beacon'
			});
		}  
	}
	function sendClick(adbrand, adlocation, adlink) {
		if(adbrand != undefined && adlink !="" && adlink != "#"){
			__gaTracker('send', {
				hitType: 'event',
				eventCategory: "Sponsored click",
				eventAction: adlocation,
				eventLabel: adbrand,
				transport: 'beacon'
			});
		}
	}
jQuery(document).ready( function () {
	jQuery('.ad-tracking-ga').each( function () {
		if ( jQuery(this).is(":visible")) {
			adbrand = jQuery(this).data('brand');
			adlocation = jQuery(this).data('location');
			sendImpression(adbrand,adlocation); 
		}
	});
	jQuery('.ad-tracking-ga').click( function () {
		adbrand = jQuery(this).data('brand');
		adlocation = jQuery(this).data('location');
		adlink = jQuery(this).attr('href');
		sendClick(adbrand,adlocation,adlink); 
	});
});